/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import GetStartedModal from "./GetStartedModal.container";

export default GetStartedModal;
